import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FinAppToolComponent } from './component/finapp-tool.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FinAppToolService } from './services/finapp-tool.service';
import { FinappConsentService } from './services/finapp-consent.service';
import { ConsentCMSService } from './services/finapp-consent-cms.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [
    FinAppToolComponent
  ],
  providers: [
    FinAppToolService,
    ConsentCMSService,
    FinappConsentService
  ],
  exports: [
    FinAppToolComponent
  ],
  entryComponents: [
    FinAppToolComponent
  ]
})
export class FinAppToolModule { }
